// react
import React, { Component } from 'react'

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value || ''
    }
  }
  componentWillReceiveProps(nextProps) {
    const { value: valueNext } = nextProps
    const { value } = this.state
    if (
      Boolean(valueNext) &&
      valueNext !== value &&
      Boolean(this.select)
    ) {
      this.setState({ value: valueNext })
    }
  }
  onCheckSelection = ({ target }) => {
    const { value } = target
    const { onChange } = this.props

    this.setState({ value }, () => {
      onChange(value)
    })
  }
  getClasses = () => {
    const {
      noPadding,
      defaultWith,
    } = this.props
    const { value } = this.state
    const classStyle = `${!noPadding ? 'add-space-bottom' : ''}`
    const parentClass = 'sb-select select-status input-focus-message'
    const selectClass = `${value !== '' ? '' : ' grayColor'} ${defaultWith ? 'default-width' : ''}`

    return {
      selectClass,
      parentClass,
      classStyle
    }
  }
  render() {
    const {
      props: {
        id,
        dataModel,
        dataModelId,
        dataAttribute,
        options
      },
      state: { value },
      getClasses,
      onCheckSelection
    } = this
    const {
      selectClass,
      parentClass,
      classStyle
    } = getClasses()
    let finalOptions = [['Select an option', '']]
    if (options?.length > 0) {
      finalOptions = finalOptions.concat(options)
    }

    return (
      <div className={classStyle}>
        <div className={parentClass}>
          <label htmlFor={id}>
            <select
              ref={el => this.select = el}
              data-model={dataModel}
              value={value}
              data-model-id={dataModelId}
              data-attribute={dataAttribute}
              id={id}
              onChange={onCheckSelection}
              className={selectClass}
            >
              {finalOptions.map(([label, value], index) => (
                <option
                  disabled={index === 0}
                  value={value}
                  key={`opt-${value}`}
                >
                  {label}
                </option>
                )
              )}
            </select>
          </label>
        </div>
      </div>
    )
  }
}

export default Dropdown
